import type { EWidgetSection } from '#shared';
import type { WidgetType } from '../../widgetManager';

export interface GeoMapParseResult {
  widgetType: WidgetType;
  restrictToSection: EWidgetSection | null;
}

/**
 * Parse special geo-map IDs (geo-map-center, geo-map-focus) into widget type and section restriction
 */
export const parseGeoMapId = (
  draggedId: string,
  targetSectionId: EWidgetSection,
): GeoMapParseResult => {
  if (draggedId === 'geo-map-center') {
    return {
      widgetType: 'geo-map',
      restrictToSection: 'center' as EWidgetSection,
    };
  }

  if (draggedId === 'geo-map-focus') {
    return {
      widgetType: 'geo-map',
      restrictToSection: targetSectionId === 'center' ? null : targetSectionId,
    };
  }

  return {
    widgetType: draggedId as WidgetType,
    restrictToSection: null,
  };
};

/**
 * Validate geo-map section restrictions
 */
export const validateGeoMapPlacement = (
  draggedId: string,
  targetSectionId: EWidgetSection,
  restrictToSection: EWidgetSection | null,
): { valid: boolean; errorMessage?: string } => {
  // Check section restriction for geo-map items
  if (restrictToSection === 'center' && targetSectionId !== 'center') {
    return {
      valid: false,
      errorMessage: 'Geo Map can only be placed in Center section',
    };
  }

  if (draggedId === 'geo-map-focus' && targetSectionId === 'center') {
    return {
      valid: false,
      errorMessage: 'Focus View cannot be placed in Center section',
    };
  }

  return { valid: true };
};
